<template>
    <v-layout v-if="ready" justify-center>
        <v-responsive max-width="1024px" width="100%" height="100%" class="shop-product-view">
            <div class="headline text-start mt-8">제품 파일 업로드</div>
                <v-container>
                    <v-row class="mt-4">
                        <v-col cols="12">
                            <v-card>
                                <v-card-title class="subtitle-1">엑셀 파일</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col>
                                            <v-file-input v-model="file" accept=".xlsx" @change="file => change(file)"/>
                                        </v-col>
                                    </v-row>
                                    <v-card-actions>
                                        <v-spacer />
                                        <v-btn color="primary" @click="postProduct">저장</v-btn>
                                    </v-card-actions>
                                </v-card-text>
                            </v-card>

                            <v-card class="mt-4">
                                <v-card-title class="subtitle-2 font-weight-bold">썸네일</v-card-title>
                                <v-divider />
                                <v-card-text class="pt-0">
                                    <div class="mt-4 text-center" v-if="product.thumbs < 1">
                                        선택된 파일이 없습니다.
                                    </div>
                                    <draggable v-model="product.thumbs">
                                        <v-hover v-for="(image, index) in product.thumbs" :key="`slide-${index}`">
                                            <v-card style="position:relative" class="mt-4">
                                                <v-row class="mx-4">
                                                    <v-col>
                                                        <v-list>{{image.name}}</v-list>
                                                    </v-col>
                                                    <v-col>
                                                        <v-icon large class="ml-3" @click="product.thumbs.splice(index, 1)">
                                                            mdi-delete
                                                        </v-icon>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </v-hover>
                                    </draggable>
                                </v-card-text>
                                <v-divider />
                                <v-card-actions>
                                    <v-file-btn outlined color="primary" multiple @change="uploadThumb">
                                        <v-icon class="mr-2">mdi-cloud-upload</v-icon>
                                        <span>이미지 업로드</span>
                                    </v-file-btn>
                                    <v-spacer />
                                    <v-btn color="primary" @click="postExcelThumbImage">
                                        <v-icon class="mr-2">mdi-content-save</v-icon>
                                        <span>저장하기</span>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>

                            <v-card class="mt-4">
                                <v-card-title class="subtitle-2 font-weight-bold">게시물 사진</v-card-title>
                                <v-divider />
                                <v-card-text class="pt-0">
                                    <div class="mt-4 text-center" v-if="product.images < 1">
                                        선택된 파일이 없습니다.
                                    </div>
                                    <draggable v-model="product.images">
                                        <v-hover v-for="(image, index) in product.images" :key="`slide-${index}`">
                                            <v-card style="position:relative" class="mt-4">
                                                <v-row class="mx-4">
                                                    <v-col>
                                                        <v-list>{{image.name}}</v-list>
                                                    </v-col>
                                                    <v-col>
                                                        <v-icon large class="ml-3" @click="product.images.splice(index, 1)">
                                                            mdi-delete
                                                        </v-icon>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </v-hover>
                                    </draggable>
                                </v-card-text>
                                <v-divider />
                                <v-card-actions>
                                    <v-file-btn outlined color="primary" multiple @change="upload">
                                        <v-icon class="mr-2">mdi-cloud-upload</v-icon>
                                        <span>이미지 업로드</span>
                                    </v-file-btn>
                                    <v-spacer />
                                    <v-btn color="primary" @click="postExcelImage">
                                        <v-icon class="mr-2">mdi-content-save</v-icon>
                                        <span>저장하기</span>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>

                            <!-- <v-card class="mt-4">
                                <v-card-title class="subtitle-1">제품 이미지 파일</v-card-title>
                                <v-card-text>
                                    <v-row class="pt-0 pb-0">
                                        <v-col cols="auto" class="pt-2 pb-0">
                                            <v-img v-if="images[0] || product.images[0]" :src="images[0] ? createObjectURL(images[0]) : product.images[0]" width="128" height="128"></v-img>
                                            <v-responsive v-else width="128" height="128">
                                                <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                                    <v-icon>mdi-image</v-icon>
                                                </v-row>
                                            </v-responsive>
                                        </v-col>
                                        <v-col>
                                            <v-file-input v-model="images" show-size dense accept="image/*" @change="file => postExcelImage(file)"></v-file-input>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card> -->
                        </v-col>
                    </v-row>
                </v-container>

        </v-responsive>
    </v-layout>
</template>

<script>
import XLSX from "xlsx";
import draggable from "vuedraggable";
import VFileBtn from "@/components/vuetify/v-file-btn.vue";


export default {
    components: {
        draggable,
        VFileBtn
    },
    data: () => {
        return {
            ready: false,

            ///////////////////////////////////////////////
            // 상품정보
            ///////////////////////////////////////////////
            product: {
                excel: [],
                images: [],
                thumbs: []
            },

            ///////////////////////////////////////////////
            // UI
            ///////////////////////////////////////////////
            thumbs: [],
            file: null,
            excel: null,
            images: new Array(),
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            try{

                this.ready = true;
            }
            catch(error){
                console.error(error);
                if(error.response) alert(error.response.data.message);
            }
        },

        postProduct(){
            return new Promise(async (resolve, reject) => {
                try{
                    this.change()
                    var res = await this.$http.post('/api/console/shop/products/excel', this.product);

                    resolve(res.data.product);
                    alert("저장됐습니다.");
                    this.$router.go(-1)
                }
                catch(error){
                    reject(error);
                }
            });
        },

        change(file) { //엑셀 파일 변환
            if (!file) return;

            let reader = new FileReader();
            reader.onload = () => {
                var workSheets = [];
                var workBook = XLSX.read(reader.result, { type: "binary" });
                workBook.SheetNames.forEach(sheetName => {
                    let sheet = XLSX.utils.sheet_to_json(
                        workBook.Sheets[sheetName]
                    );
                    workSheets.push(sheet);
                });

                let [workSheet] = workSheets;
                for(let i = 1; i < workSheet.length; i++){
                    this.product.excel.push({
                        "_category": workSheet[i]["2차카테고리"],
                        "bestMatchs": workSheet[i]["베스트매치 (줄은 /로 구분 ex)테라코타 화이트,조이풀 그레이/테라코타 화이트 )"],
                        "bestMatchsEnabled": workSheet[i]["베스트매치 사용여부"],
                        "code": workSheet[i]["code"],
                        "color": workSheet[i]["color"],
                        "content": workSheet[i]["상품 상세 설명 (<p>문단</p>)"],
                        "design": workSheet[i]["design"],
                        "images": workSheet[i]["이미지이름"],
                        "match": workSheet[i]["match"],
                        "material": workSheet[i]["material"],
                        "name": workSheet[i]["제품이름"],
                        "repeat": workSheet[i]["repeat"],
                        "size": workSheet[i]["Dimension"],
                        "style": workSheet[i]['style ["",""]'],
                        "thumb": workSheet[i]["썸네일"],
                        "usage": workSheet[i]["purpose"],
                        "weight": workSheet[i]["weight"],
                    })
                }

                this.product.excel 

                this.show = true;
            };
            reader.readAsBinaryString(file);
        },

        uploadThumb(files) { // 이미지 갯수 늘리기
            this.product.thumbs = [...files, ...this.product.thumbs];
        },

        upload(files) { // 이미지 갯수 늘리기
            this.product.images = [...files, ...this.product.images];
        },

        async postExcelThumbImage(){ // 썸네일 이미지 저장
            for(let img of this.product.thumbs) {
                var data = new FormData();
                data.append('image', img);
                await this.$http.post(`/api/console/shop/products/excelThumbImg`, data, {
                    headers: {
                        'Content-Type' : 'multipart/form-data'
                    }
                });
            }
            alert("저장됐습니다.");
            this.$router.go(-1)
        },

        async postExcelImage(){ // 썸네일 이미지 저장
            for(let img of this.product.images) {
                var data = new FormData();
                data.append('image', img);

                await this.$http.post(`/api/console/shop/products/excelImg` , data, {
                    headers: {
                        'Content-Type' : 'multipart/form-data'
                    }
                });
            }
            alert("저장됐습니다.");
            this.$router.go(-1)
        },

    },
    computed: {
    },
    watch: {
    }

}
</script>

<style>
.shop-product-view .weight input { text-align: end; }
.shop-product-view .amount input { text-align: end; }
.shop-product-view .theme--light.v-tabs-items { background-color: transparent !important; }
.shop-product-view .option-groups-headers th { border-bottom: thin solid rgba(0,0,0,.12) }
</style>
